__turbopack_context__.v({
  "active": "gameCard-module-scss-module__g1T4UG__active",
  "bottomLink": "gameCard-module-scss-module__g1T4UG__bottomLink",
  "cardButton": "gameCard-module-scss-module__g1T4UG__cardButton",
  "cardChannel": "gameCard-module-scss-module__g1T4UG__cardChannel",
  "cardChannelNum": "gameCard-module-scss-module__g1T4UG__cardChannelNum",
  "cardChannelNumTablet": "gameCard-module-scss-module__g1T4UG__cardChannelNumTablet",
  "cardDropdownLeft": "gameCard-module-scss-module__g1T4UG__cardDropdownLeft",
  "cardDropdownRight": "gameCard-module-scss-module__g1T4UG__cardDropdownRight",
  "container": "gameCard-module-scss-module__g1T4UG__container",
  "copyright": "gameCard-module-scss-module__g1T4UG__copyright",
  "date": "gameCard-module-scss-module__g1T4UG__date",
  "dual": "gameCard-module-scss-module__g1T4UG__dual",
  "dualInfo": "gameCard-module-scss-module__g1T4UG__dualInfo",
  "emptyChannel": "gameCard-module-scss-module__g1T4UG__emptyChannel",
  "hoverDetectorLeft": "gameCard-module-scss-module__g1T4UG__hoverDetectorLeft",
  "hoverDetectorRight": "gameCard-module-scss-module__g1T4UG__hoverDetectorRight",
  "imageRow": "gameCard-module-scss-module__g1T4UG__imageRow",
  "infoCol": "gameCard-module-scss-module__g1T4UG__infoCol",
  "infoRow": "gameCard-module-scss-module__g1T4UG__infoRow",
  "leftImage": "gameCard-module-scss-module__g1T4UG__leftImage",
  "leftTitle": "gameCard-module-scss-module__g1T4UG__leftTitle",
  "modalDesktop": "gameCard-module-scss-module__g1T4UG__modalDesktop",
  "rightImage": "gameCard-module-scss-module__g1T4UG__rightImage",
  "rightTitle": "gameCard-module-scss-module__g1T4UG__rightTitle",
  "rowIcon": "gameCard-module-scss-module__g1T4UG__rowIcon",
  "single": "gameCard-module-scss-module__g1T4UG__single",
  "singleInfo": "gameCard-module-scss-module__g1T4UG__singleInfo",
  "singleLink": "gameCard-module-scss-module__g1T4UG__singleLink",
  "team1IconBlack": "gameCard-module-scss-module__g1T4UG__team1IconBlack",
  "team1IconWhite": "gameCard-module-scss-module__g1T4UG__team1IconWhite",
  "team2IconBlack": "gameCard-module-scss-module__g1T4UG__team2IconBlack",
  "team2IconWhite": "gameCard-module-scss-module__g1T4UG__team2IconWhite",
  "teamsInfoCol": "gameCard-module-scss-module__g1T4UG__teamsInfoCol",
  "teamsInfoRow": "gameCard-module-scss-module__g1T4UG__teamsInfoRow",
  "wrapper": "gameCard-module-scss-module__g1T4UG__wrapper",
});
